import { Capacitor, registerPlugin } from '@capacitor/core';

const PLUGIN = 'TrainingScreenAwake';
let plugin;
let initialization;

function nativePlugin() {
  try {
    // Older app binaries do not have this local plugin: keep their web fallback intact.
    if (!Capacitor.isNativePlatform() || !Capacitor.isPluginAvailable(PLUGIN)) return null;
    if (!plugin) plugin = registerPlugin(PLUGIN);
    return plugin;
  } catch { return null; }
}

// Once per fresh WebView boot, discard any intent left by a reload/crashed JS context.
// All later acquisitions await this reset, so it cannot release a newly started session.
export function initializeNativeScreenAwake() {
  const native = nativePlugin();
  if (!native) return null;
  if (!initialization) {
    try { initialization = Promise.resolve(native.reset()).catch(() => {}); }
    catch { initialization = Promise.resolve(); }
  }
  return initialization;
}

export function getNativeScreenAwake() {
  const native = nativePlugin();
  return native ? { plugin: native, ready: initializeNativeScreenAwake() } : null;
}
